/* eslint-disable array-callback-return */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-anonymous-default-export */
import { quickActionPinMobileIcon, quickActionShareMobileIcon, imsLoader, crossIcon, quickActionIcon, supportingDocumentMobTabIcon, JJIconDocument } from "../../assets"
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import trackingService from "../../services/trackingService";
import GenerateArrayStrings from '../GenerateArrayStrings';
import SharePopup from "../GenAISharePopup";
import './ActionBar.css';
import GenAIPinToReadingListPopUp from "../GenAIPopUp/GenAIPinToReadingListPopUp";
import DocumentPreview from "../Preview/DocumentPreview";
import AiNotebookDocumentPreview from "../Preview/AiNotebookDocumentPreview";
import { Modal } from "react-bootstrap";
import { LocationOrigin, isShowAuthoring } from "../../utils/utilityServices";
import axios from "axios";
import { Authentication } from "../../utils/authenticationUtilityServices";
import GenAIAuthoringIndex from "../GenAIAnswering2.0/GenAIAuthoringIndex";
import { v4 as uuidv4 } from 'uuid';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import AuthoringDisclaimer from "../Authoring/AuthoringDisclaimer";
import AuthoringEnablePanel from "../Authoring/AuthoringEnablePanel";
import ApiServices from "../../utils/apiServices";

let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
let _timeoutTime = (1000 * (300));

const indexData = (item, url, appliedFilters, searchKeyword, pageNumber, pageSize, shareoption, csPath, csProduct) => {
    let newUrl = window.origin + url;
    const ts = new trackingService();
    if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, item.r_version_label, item.jj_number, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else if (item.domain === 'SKM') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, '', item.domain, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else if (item.domain === 'CTGov') {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, '', item.docID, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
        else {
            ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.docTitle, item.majorVersionNumber, item.documentNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, item.domain, pageNumber, pageSize, item.createdDate, orderedBy, orderedFor);
        }
    }
    else {
        ts.indexTrackingData(localStorage.getItem('userdisplayName'), localStorage.getItem('wwid'), localStorage.getItem('username'), localStorage.getItem('function'), localStorage.getItem('region'), localStorage.getItem('userproducts'), localStorage.getItem('doctypepref'), localStorage.getItem('sid'), localStorage.getItem('deviceType'), localStorage.getItem('deviceOS'), localStorage.getItem('browserName'), localStorage.getItem('browserVersion'), localStorage.getItem('jnjDepartment'), localStorage.getItem('companyname'), `${shareoption} Document`, '', window.location.href, searchKeyword, appliedFilters, item.title, item.majorVersionNumber, item.documentNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, `${shareoption} Document`, csPath, csProduct, 'PubMed', pageNumber, pageSize, item.createdDate);
    }
}
const handleSupportingDocs = (url) => {

    const queryParams = new URLSearchParams(document.location.search);
    const params = queryParams.get("query");
    const filters = queryParams.get("filters");
    const q = queryParams.get("q");
    const majorTopicsSynonyms = queryParams.get("majorTopicsSynonyms");
    const authors = queryParams.get("authors");
    const docTitle = queryParams.get("docTitle");
    let str = "";
    let fieldedSearch = queryParams.get("FS");
    let limistArr = [];
    let searchDes = "";
    if (window.location.pathname !== "/ReferencesUsed") {
        if (
            params !== "" &&
            filters !== "" &&
            q !== "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${q}: ${params}: ${filters}`;
        } else if (
            params === "" &&
            filters !== "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${filters}`;
        } else if (
            params !== "" &&
            filters !== "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${params}: ${filters}`;
        } else if (
            params !== "" &&
            filters === "" &&
            q === "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${params}`;
        } else if (
            params !== "" &&
            filters === "" &&
            q !== "All Fields" &&
            !fieldedSearch
        ) {
            searchDes = `${q}: ${params}`;
        } else if (fieldedSearch) {
            // Publication Year
            let toRange = queryParams.get("toYear");
            let fromRange = queryParams.get("fromYear");
            let PublicationYear = "";
            if (toRange) {
                toRange = parseInt(toRange);
            }
            if (fromRange) {
                fromRange = parseInt(fromRange);
            }
            let strYear = limistArr.find((x) => x.key === "strYear");
            if (strYear) {
                let strYearValue = parseInt(strYear.value);
                if (
                    toRange &&
                    fromRange &&
                    fromRange <= strYearValue &&
                    toRange >= strYearValue
                ) {
                    PublicationYear = `${fromRange} To ${toRange}`;
                } else if (
                    toRange &&
                    fromRange &&
                    (fromRange > strYearValue || toRange < strYearValue)
                ) {
                    PublicationYear = `${fromRange} To ${toRange} AND ${strYearValue}`;
                } else if (toRange && strYearValue) {
                    PublicationYear = `${toRange} and earlier AND ${strYearValue}`;
                } else if (fromRange && strYearValue) {
                    PublicationYear = `${fromRange} and later AND ${strYearValue}`;
                } else if (strYearValue) {
                    PublicationYear = `${strYearValue}`;
                }
            } else if (toRange && fromRange) {
                PublicationYear = `${fromRange} To ${toRange}`;
            } else if (toRange) {
                PublicationYear = `${toRange} and earlier`;
            } else if (fromRange) {
                PublicationYear = `${fromRange} and later`;
            }
            limistArr = limistArr.filter((x) => x.key !== "strYear");
            let fcount = queryParams.get("fcount");
            for (let i = 0; i < fcount; i++) {
                let key = queryParams.get(`f${i + 1}`);
                let value = queryParams.get(`fval${i + 1}`);
                limistArr[i] = { key: key, value: value };
            }
            str = params ? `(${params}${filters ? `: ${filters})` : ")"}` : "";
            str = str + (docTitle ? ` (Title: ${docTitle})` : "");
            str = str + (authors ? ` (Authors: ${authors})` : "");
            str =
                str +
                (majorTopicsSynonyms
                    ? ` (Major Topics: ${majorTopicsSynonyms})`
                    : "");
            str =
                str +
                (PublicationYear ? ` (Publication Year: ${PublicationYear})` : "");
            if (fcount > 0 && limistArr.length > 0) {
                limistArr.map((item, index) => {
                    str =
                        str +
                        (item.key
                            ? ` (${this.conversionOfFieldType(item.key)}: ${item.value})`
                            : "");
                });
            }
            searchDes = str;
        }

    }
    let width = 0.80 * window.innerWidth
    let height = 0.85 * window.innerHeight
    let left = 0.10 * window.innerWidth
    let top = 0.10 * window.innerHeight
    let newWindow = window.open(url, '', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
    newWindow.supportingDocsSearchStrategyDescription = searchDes;
    newWindow.isSupportingDocs = true;
    //OpenWindow(url)
}
const handleMIAsDocs = (refurl) => {
    let url = `/ReferencesUsed?query=${refurl}`;
    window.open(url, '', `width=${window.innerWidth},height=${window.innerHeight},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
}
export default function (props) {
    const {
        item,
        appliedFilters,
        searchKeyword,
        pageNumber,
        pageSize,
        customWidth,
        collapsed,
        csPath,
        csproduct,
        handleUnpin,
        synonymsForDocumentPreview
    } = props
    const [isOpen, setOpenState] = useState(false)
    const [, setqaCollapsed] = useState(false)
    const [showActions, setShowActions] = useState(false)
    const [showReadingList, setShowRL] = useState(false)
    const [showPreview, setPreview] = useState(false)
    const [showAuthoring, setAuthoring] = useState(false)
    const [attachedFiles, setAttachedFiles] = useState([])
    const [sessionID, setSessionID] = useState();
    const [threadID, setThreadID] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [selectedTab, setSelectedTab] = useState('0');
    const [showDisclaimerPopup, setShowDisclaimerPopup] = useState();
    const [showAuthoringEnablePanel, setShowAuthoringEnablePanel] = useState(false)
    const handleAuthoringClickRef = useRef(null)

    useEffect(() => {
        if (showAuthoring === true) {
            handleAuthoringClickRef.current();
        }
    }, [showAuthoring])


    /*useEffect(()=>{
       setSessionID(guid)
    },[])*/

    let url, supportingDocUrl, docIds, referencesUrl
    if (item.supportingDocIDs) {
        docIds = GenerateArrayStrings(item.supportingDocIDs)
        supportingDocUrl = `?query=&q=All%20Fields&filters=&f1=docID&fval1=${docIds}&fcount=1`
    }
    if (item.domain === "MIAs") {
        if (item.spoWebURL) {
            referencesUrl = item.spoWebURL.split('/')
            referencesUrl.pop();
            referencesUrl.push('references used')
            referencesUrl = referencesUrl.join('/')
        }
    }
    if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            // url = `/DocURL?ID=${item.docTitle}&cs=${item.domain}`
        }
        else if (item.domain === 'SKM' || item.domain === "MIAs") {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                url = url + `&docState=anr`
            }
        }
        if (item.enclosureDocID) {
            url += `&enclosureID=${item.enclosureDocID}`
        }
    }
    else {
        url = `/DocURLPubMed?sid=PMS&pmid=${item.PMID}`
    }
    useEffect(() => {
        if (collapsed) {
            setqaCollapsed(true)
        }
        else {
            setqaCollapsed(false)
        }
    }, [collapsed])
    function handleShowActions() {
        setShowActions(false)
    }
    function handleClosePinToReadingList(status) {
        setShowRL(status)
    }
    function onDownloadClick() {
        indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Download', csPath !== null ? csPath : '', csproduct !== null ? csproduct : '')
    }
    function onPubMedDownloadClick() {
        indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Download PubMed', csPath !== null ? csPath : '', csproduct !== null ? csproduct : '')
    }
    function onShareClick() {
        setOpenState(!isOpen);
        if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
            indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Share', '', '')
        }
        else {
            indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Share PubMed', '', '')
        }
    }
    function handlePreviewClose(status) {
        setPreview(false);
        setAuthoring(false);
        setSelectedTab('0')
    }
    async function multipleFilesUpload(attached_Files, value) {
        //let { attachedFiles, sessionID, updateAnyFile, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        let session_id = uuidv4()
        setSessionID(session_id)
        const formData = new FormData();
        attached_Files.map((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attached_Files.length);
        formData.append(`sessionID`, session_id);
        formData.append(`threadID`, threadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                setSelectedTab('1')
            }
        }).catch((error) => {
            console.log(error)
        }).finally(() => {
            //this.setState({ isProcessing: false });
            setIsProcessing(false)
        });
    }
    async function fetchDocument() {
        let attachedFile = []
        let url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/GenAIAllPagesPreview?strID=${item.searchID}`
        //https://predev-ims.jnj.com/api/PreviewService/GenAIAllPagesPreview?strID=706d063693d4a5c9bd9c065f71ec95a8
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(
            url,
            {
                responseType: "blob",
                headers: _headers
            }
        ).then((response) => {
            let newFileName = item.fileName.split('.').slice(0, -1).join('.');
            const fileName = `${newFileName}.pdf`;
            const data = new Blob([response.data], { type: 'application/pdf' });
            var newFile = new File([data], item.fileName, { type: 'application/pdf' });
            newFile.guid = uuidv4();
            newFile.newFileName = fileName
            attachedFile.push(newFile)
            //this.setState({ base64: data, isProcessing: false })
            setAttachedFiles([newFile])
        }).catch((error) => {
            console.log(error);
            // this.setState({ base64: "", isProcessing: false })
            setAttachedFiles([])
        }).finally(async () => {
            // this.setState({ isProcessing: false })
            multipleFilesUpload(attachedFile)
        })
    }
    async function handleAuthoringClick() {
        setIsProcessing(true)
        await fetchDocument();
        //await multipleFilesUpload();
    }
    handleAuthoringClickRef.current = handleAuthoringClick;
    function handleAuthoringClose() {
        setAttachedFiles([]);
        setSessionID(null);
        setThreadID(null);
        handlePreviewClose();
    }
    function handleOnTabClick(evt) {
        let _showDisclaimerPopup = true;
        let strShowDisclaimerPopup = localStorage.getItem('showPreviewAuthoringDisclaimer');
        if (strShowDisclaimerPopup) {
            _showDisclaimerPopup = !JSON.parse(strShowDisclaimerPopup);
        }
        var tabId = evt.target.id
        if (tabId.split('-')[0] === '1' || tabId.split('-')[0] === '0') {
            /*this.setState({
                selectedTab: tabId.split('-')[0],
                showDisclaimerPopup: _showDisclaimerPopup
            })*/
            setSelectedTab(tabId.split('-')[0])
            setShowDisclaimerPopup(_showDisclaimerPopup)
            if (tabId.split('-')[0] === '1') {
                setIsProcessing(true)
                setAuthoring(true)
                setPreview(false)
            } else if (tabId.split('-')[0] === '0') {
                setPreview(true)
                setAuthoring(false)
            }
        }
    }
    async function handleDisclaimerClose() {
        let strShowDisclaimerPopup = localStorage.getItem('showPreviewAuthoringDisclaimer');
        if (strShowDisclaimerPopup && !JSON.parse(strShowDisclaimerPopup)) {
            let service = new ApiServices();
            let wwid = JSON.parse(localStorage.getItem("wwid"));
            await service.UpdateDisclaimerStatus(wwid, 'isshowpreviewauthoringdisclaimer', true);
        }
        //this.setState({ showDisclaimerPopup: false });
        setShowDisclaimerPopup(false)
        localStorage.setItem('showPreviewAuthoringDisclaimer', JSON.stringify(true));
    }
    function handleShowAuthoringEnablePanelClick() {
        setShowAuthoringEnablePanel(false)

    }
    function renderAuthoringEnablePanel(item) {
        if (item.docType
            && item.docType.includes('Publications')
            && item.genAIEnabled) {
            return (<button
                type="button"
                className={`gen-ai-action-ai-enable__button`}
                title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <span className="gen-ai-action-review__label">AI Enabled</span>
            </button>)
        }
        else if (item.docType
            && !item.docType.includes('Publications')) {
            return (<button
                type="button"
                className={`gen-ai-action-ai-enable__button`}
                title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <span className="gen-ai-action-review__label">AI Enabled</span>
            </button>)
        }
        else if (item.docType
            && item.docType.includes('Publications')
            && !item.genAIEnabled) {
            return (<button type="button"
                className={`gen-ai-action-ai-restricted__button`}
                title="AI Restricted">
                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.64"></g>
                    <g id="SVGRepo_iconCarrier">
                        <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM18 13H11V6C11 3.238 13.238 1 16 1C18.762 1 21 3.238 21 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#eb1600" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                <span className="gen-ai-action-review__label">AI Restricted</span>
            </button>)
        } else {
            return null;
        }
    }
    if (customWidth < 1000) {
        return (
            <div className="action-items-mobile-wrapper" >
                <img src={quickActionIcon} alt="" width="35" height="35" onClick={e => setShowActions(!showActions)} />
                {showActions &&
                    <div className="action-items-mobile-inner-wrapper" onMouseLeave={handleShowActions}>
                        {(window.location.pathname === '/viewReadingList' || window.location.pathname === '/old_viewReadingList' || window.location.pathname === '/GenAIViewReadingList' || window.location.pathname === '/viewPubMedReadingList') ?
                            window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-mobile-items-wrapper" onClick={e => { handleUnpin(item); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Unpin', '', ''); }}><img src={quickActionPinMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Unpin</span></div>
                            : window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-mobile-items-wrapper" onClick={e => { setShowRL(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Pin', '', '') }}><img src={quickActionPinMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Pin</span></div>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <div className="quick-action-divider-mobile"></div>}
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.supportingDocIDs !== undefined && item.supportingDocIDs.length > 0 &&
                            <>
                                <div className="action-items-mobile-items-wrapper" onClick={evt => handleSupportingDocs(supportingDocUrl)}><img src={supportingDocumentMobTabIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Supporting Documents</span></div>
                                <div className="quick-action-divider-mobile"></div>
                            </>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.domain === "MIAs" &&
                            <>
                                <div className="action-items-mobile-items-wrapper" onClick={evt => handleMIAsDocs(referencesUrl)}><img src={supportingDocumentMobTabIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">References Used</span></div>
                                <div className="quick-action-divider-mobile"></div>
                            </>
                        }
                        <div className="action-items-mobile-items-wrapper" onClick={onShareClick} ><img src={quickActionShareMobileIcon} alt="" width="30" height="30" /><span className="action-item-text-mobile">Share</span></div>
                    </div>
                }
                {isOpen &&
                    <div>
                        <SharePopup isOpen={isOpen} item={item} appliedFilters={appliedFilters} searchKeyword={searchKeyword} pageNumber={pageNumber} pageSize={pageSize} handleClose={(close) => { setOpenState(close) }} csPath={csPath} csproduct={csproduct} customWidth={customWidth}></SharePopup>
                    </div>
                }
                {showReadingList &&
                    <GenAIPinToReadingListPopUp showModal={showReadingList} handleClose={handleClosePinToReadingList} width={customWidth} docID={item.searchID} />
                }
            </div>
        )
    }
    else {
        return (<>
            <div className="action-icons">
                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') &&
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner" title="Preview">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={evt => { setPreview(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Preview', '', '') }}>
                                <g clip-path="url(#clip0_676_1771)">
                                    <path d="M1.61341 8.47543C1.52262 8.33167 1.47723 8.25979 1.45182 8.14892C1.43273 8.06565 1.43273 7.93431 1.45182 7.85104C1.47723 7.74017 1.52262 7.66829 1.61341 7.52453C2.36365 6.33654 4.59682 3.33331 8.00004 3.33331C11.4033 3.33331 13.6364 6.33654 14.3867 7.52453C14.4775 7.66829 14.5228 7.74017 14.5483 7.85104C14.5673 7.93431 14.5673 8.06565 14.5483 8.14892C14.5228 8.25979 14.4775 8.33167 14.3867 8.47543C13.6364 9.66342 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66342 1.61341 8.47543Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.00004 9.99998C9.10457 9.99998 9.99997 9.10455 9.99997 7.99998C9.99997 6.89541 9.10457 5.99998 8.00004 5.99998C6.89551 5.99998 6.00011 6.89541 6.00011 7.99998C6.00011 9.10455 6.89551 9.99998 8.00004 9.99998Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_676_1771">
                                        <rect width="15.9994" height="16" rx="4" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                }
                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ?
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner" title="Download">
                            <Link target="_blank" to={url} onClick={onDownloadClick} className="quick-action-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                    <path d="M13.9996 10V10.8C13.9996 11.9201 13.9996 12.4802 13.7816 12.908C13.5899 13.2843 13.2839 13.5903 12.9076 13.782C12.4798 14 11.9198 14 10.7997 14H5.19989C4.07982 14 3.51979 14 3.09198 13.782C2.71567 13.5903 2.40972 13.2843 2.21798 12.908C2 12.4802 2 11.9201 2 10.8V10M11.333 6.66667L7.99979 10M7.99979 10L4.66657 6.66667M7.99979 10V2" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </Link>
                        </div>
                    </div> :
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner" title="Download">
                            <Link target="_blank" to={url} onClick={onPubMedDownloadClick} className="quick-action-item">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                    <path d="M13.9996 10V10.8C13.9996 11.9201 13.9996 12.4802 13.7816 12.908C13.5899 13.2843 13.2839 13.5903 12.9076 13.782C12.4798 14 11.9198 14 10.7997 14H5.19989C4.07982 14 3.51979 14 3.09198 13.782C2.71567 13.5903 2.40972 13.2843 2.21798 12.908C2 12.4802 2 11.9201 2 10.8V10M11.333 6.66667L7.99979 10M7.99979 10L4.66657 6.66667M7.99979 10V2" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                }
                {(window.location.pathname === '/viewReadingList' || window.location.pathname === '/old_viewReadingList' || window.location.pathname === '/GenAIViewReadingList' || window.location.pathname === '/viewPubMedReadingList') ?
                    window.location.pathname !== '/pubMedResults' &&
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner" title="Unpin">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => { handleUnpin(item); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Unpin', '', ''); }}>
                                <path d="M7.99996 9.99998L7.99996 14.6666M5.33339 4.87207V6.29248C5.33339 6.43116 5.33339 6.5005 5.31978 6.56682C5.3077 6.62566 5.28773 6.6826 5.2604 6.73609C5.2296 6.79639 5.18629 6.85053 5.09966 6.95882L4.05317 8.26697C3.60936 8.82175 3.38746 9.09914 3.38721 9.33259C3.38699 9.53562 3.47929 9.72768 3.63796 9.85434C3.82041 9.99998 4.17563 9.99998 4.88607 9.99998H11.1139C11.8243 9.99998 12.1795 9.99998 12.362 9.85434C12.5206 9.72768 12.6129 9.53562 12.6127 9.33259C12.6125 9.09914 12.3906 8.82175 11.9467 8.26697L10.9003 6.95882C10.8136 6.85053 10.7703 6.79639 10.7395 6.73609C10.7122 6.6826 10.6922 6.62566 10.6801 6.56682C10.6665 6.5005 10.6665 6.43116 10.6665 6.29248V4.87207C10.6665 4.79532 10.6665 4.75694 10.6709 4.7191C10.6747 4.68548 10.6811 4.6522 10.69 4.61956C10.7001 4.58281 10.7143 4.54718 10.7428 4.47592L11.4147 2.79613C11.6107 2.30607 11.7087 2.06104 11.6679 1.86434C11.6321 1.69233 11.5299 1.54139 11.3835 1.44432C11.2161 1.33331 10.9522 1.33331 10.4244 1.33331H5.57555C5.04776 1.33331 4.78386 1.33331 4.61642 1.44432C4.46999 1.54139 4.3678 1.69233 4.33206 1.86434C4.29118 2.06104 4.38919 2.30607 4.58521 2.79613L5.2571 4.47592C5.2856 4.54718 5.29985 4.58281 5.30988 4.61956C5.31879 4.6522 5.3252 4.68548 5.32905 4.7191C5.33339 4.75694 5.33339 4.79532 5.33339 4.87207Z" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div> :
                    window.location.pathname !== '/pubMedResults' &&
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner" title="Pin">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={e => { setShowRL(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Pin', '', '') }}>
                                <path d="M7.99996 9.99998L7.99996 14.6666M5.33339 4.87207V6.29248C5.33339 6.43116 5.33339 6.5005 5.31978 6.56682C5.3077 6.62566 5.28773 6.6826 5.2604 6.73609C5.2296 6.79639 5.18629 6.85053 5.09966 6.95882L4.05317 8.26697C3.60936 8.82175 3.38746 9.09914 3.38721 9.33259C3.38699 9.53562 3.47929 9.72768 3.63796 9.85434C3.82041 9.99998 4.17563 9.99998 4.88607 9.99998H11.1139C11.8243 9.99998 12.1795 9.99998 12.362 9.85434C12.5206 9.72768 12.6129 9.53562 12.6127 9.33259C12.6125 9.09914 12.3906 8.82175 11.9467 8.26697L10.9003 6.95882C10.8136 6.85053 10.7703 6.79639 10.7395 6.73609C10.7122 6.6826 10.6922 6.62566 10.6801 6.56682C10.6665 6.5005 10.6665 6.43116 10.6665 6.29248V4.87207C10.6665 4.79532 10.6665 4.75694 10.6709 4.7191C10.6747 4.68548 10.6811 4.6522 10.69 4.61956C10.7001 4.58281 10.7143 4.54718 10.7428 4.47592L11.4147 2.79613C11.6107 2.30607 11.7087 2.06104 11.6679 1.86434C11.6321 1.69233 11.5299 1.54139 11.3835 1.44432C11.2161 1.33331 10.9522 1.33331 10.4244 1.33331H5.57555C5.04776 1.33331 4.78386 1.33331 4.61642 1.44432C4.46999 1.54139 4.3678 1.69233 4.33206 1.86434C4.29118 2.06104 4.38919 2.30607 4.58521 2.79613L5.2571 4.47592C5.2856 4.54718 5.29985 4.58281 5.30988 4.61956C5.31879 4.6522 5.3252 4.68548 5.32905 4.7191C5.33339 4.75694 5.33339 4.79532 5.33339 4.87207Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                }
                <div className="gen-ai-action-icon-btn" data-property-1="Default">
                    <div className="gen-ai-action-icon-btn-inner" title="Share">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onShareClick}>
                            <path d="M13.8605 8.40495C14.0232 8.26545 14.1046 8.1957 14.1344 8.1127C14.1606 8.03985 14.1606 7.96017 14.1344 7.88732C14.1046 7.80432 14.0232 7.73457 13.8605 7.59507L8.21354 2.75466C7.93339 2.51453 7.79332 2.39446 7.67473 2.39152C7.57167 2.38896 7.47322 2.43425 7.40809 2.51416C7.33315 2.60612 7.33315 2.79061 7.33315 3.15959V6.0231C5.91008 6.27207 4.60764 6.99318 3.63975 8.07592C2.58453 9.25635 2.00082 10.784 2 12.3673V12.7753C2.69954 11.9326 3.57295 11.251 4.56042 10.7773C5.43101 10.3596 6.37212 10.1122 7.33315 10.047V12.8404C7.33315 13.2094 7.33315 13.3939 7.40809 13.4859C7.47322 13.5658 7.57167 13.6111 7.67473 13.6085C7.79332 13.6056 7.93339 13.4855 8.21354 13.2454L13.8605 8.40495Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                    </div>
                </div>
                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.supportingDocIDs !== undefined && item.supportingDocIDs.length > 0 &&

                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner">
                            <a href="javascript:void(0)" onClick={evt => handleSupportingDocs(supportingDocUrl)} className="gen-ai-quick-action-item">
                                <img src={JJIconDocument} alt="" class="gen-ai-ims-result-citation-icon-black" title="Supporting Documents" />
                            </a>
                        </div>
                    </div>
                }
                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.domain === "MIAs" &&
                    <div className="gen-ai-action-icon-btn" data-property-1="Default">
                        <div className="gen-ai-action-icon-btn-inner">
                            <a href="javascript:void(0)" onClick={evt => handleMIAsDocs(referencesUrl)} className="gen-ai-quick-action-item">
                                <img src={JJIconDocument} class="gen-ai-ims-result-citation-icon-black" alt="" title="References Used" />
                            </a>
                        </div>
                    </div>
                }
                {(window.location.pathname !== '/pubMedResults'
                    && window.location.pathname !== '/viewPubMedReadingList')
                    && (isShowAuthoring()) && <>
                        {renderAuthoringEnablePanel(item)}
                        {/* {(() => {
                            if (true) {
                                return (<button
                                    type="button"
                                    className={`gen-ai-action-ai-enable__button`}
                                    title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled', '', '') }}>
                                    <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    <span className="gen-ai-action-review__label">AI Enabled</span>
                                </button>)
                            } else {
                                {
                                    item.domain !== "MLR" ? <button
                                        type="button"
                                        className={`gen-ai-action-ai-enable__button`}
                                        title="AI Enabled" onClick={async (evt) => { setSelectedTab('1'); setAuthoring(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Authoring', '', '') }}>
                                        <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                        <span className="gen-ai-action-review__label">AI Enabled</span>
                                    </button> : <>
                                    {(() => {
                                        if (item.docType
                                            && item.docType.includes('Publications')
                                            && item.genAIEnabled) {
                                            return (<button
                                                type="button"
                                                className={`gen-ai-action-ai-enable__button`}
                                                title="AI Enabled" onClick={async (evt) => { setShowAuthoringEnablePanel(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'AI Enabled for MLR Publications', '', '') }}>
                                                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                                <span className="gen-ai-action-review__label">AI Enabled</span>
                                            </button>)
                                        }
                                        else if (item.docType
                                            && !item.docType.includes('Publications')) {
                                            return (<button
                                                type="button"
                                                className={`gen-ai-action-ai-enable__button`}
                                                title="AI Enabled" onClick={async (evt) => { setSelectedTab('1'); setAuthoring(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Authoring', '', '') }}>
                                                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM1 9V6C1 3.238 3.238 1 6 1C8.762 1 11 3.238 11 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#008000" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                                <span className="gen-ai-action-review__label">AI Enabled</span>
                                            </button>)
                                        }
                                        else if (item.docType
                                            && item.docType.includes('Publications')
                                            && !item.genAIEnabled) {
                                            return (<button type="button"
                                                className={`gen-ai-action-ai-restricted__button`}
                                                title="AI Restricted">
                                                <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.64"></g>
                                                    <g id="SVGRepo_iconCarrier">
                                                        <path d="M16 21V23M16 21C15.447 21 15 20.553 15 20C15 19.447 15.447 19 16 19C16.553 19 17 19.447 17 20C17 20.553 16.553 21 16 21ZM18 13H11V6C11 3.238 13.238 1 16 1C18.762 1 21 3.238 21 6V13H26C26.594 13 27 13.469 27 14V20C27 26.075 22.075 31 16 31C9.925 31 5 26.075 5 20V14C5 13.437 5.453 13 6 13H8" stroke="#eb1600" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                                <span className="gen-ai-action-review__label">AI Restricted</span>
                                            </button>)
                                        }
                                    })()}
                                </>
                                }
                            }
                        })()} */}


                    </>}
                {/* <button type="button" onClick={() => { setShowAuthoringEnablePanel(!showAuthoringEnablePanel) }}>showAuthoringEnablePanel</button> */}
                {/*     <div className="gen-ai-action-icon-btn" data-property-1="Default"><div className="gen-ai-action-icon-btn-inner">


                    </div> </div>*/}

            </div>
            {/* <div className="action-items-wrapper"> */}
            {/* <div className="action-items-inner-wrapper-header" onClick={handleCollapsedQuickAction}>
                    <div className="action-items-main-text">
                        Quick Actions &nbsp;
                        <img src={quickActionDropDown} alt="dropdownIcon" style={{ transform: !qacollapsed ? "matrix(-1, 0, 0, -1, 0, 0)" : null, margin: "0px 0px 1.5%" }} />
                    </div>
                </div> 
                <div className="quick-action-divider"></div>*/}
            <>
                {/* {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <>
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={ evt => { setPreview(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Preview', '', '') }}>
                                    <img src={previewIcon} alt="" title="Preview" width={20} height={20} />
                                    <div className="action-items-title">
                                        Preview
                                    </div>
                                </a>
                            </div>
                            <div className="quick-action-divider"></div>
                        </>}
                        {item.domain !== "MLR" && (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && (userAccessGroup.includes(Authoring) || _function === "Medical") && <>
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={async (evt) => { setSelectedTab('1');setAuthoring(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Authoring', '', '') }}>
                                    <img src={iconAuthoringBlue} alt="" title="Authoring" width={20} height={20} />
                                    <div className="action-items-title">
                                        Authoring
                                    </div>
                                </a>
                            </div>
                            <div className="quick-action-divider"></div>
                        </>}
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.supportingDocIDs !== undefined && item.supportingDocIDs.length > 0 &&
                            <>
                                <div className="action-items-inner-wrapper">
                                    <a href="javascript:void(0)" onClick={evt => handleSupportingDocs(supportingDocUrl)} className="quick-action-item">
                                        <img src={supportingDocumentWebIcon} alt="" title="Supporting Documents" />
                                        <div className="action-items-supportingDocument-title">
                                            Supporting Documents
                                        </div>
                                    </a>
                                </div>
                                <div className="quick-action-divider"></div>
                            </>
                        }
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && item.domain === "MIAs" &&
                            <>
                                <div className="action-items-inner-wrapper">
                                    <a href="javascript:void(0)" onClick={evt => handleMIAsDocs(referencesUrl)} className="quick-action-item">
                                        <img src={supportingDocumentWebIcon} alt="" title="References Used" />
                                        <div className="action-items-supportingDocument-title">
                                            References Used
                                        </div>
                                    </a>
                                </div>
                                <div className="quick-action-divider"></div>
                            </>
                        }
                        <div className="action-items-inner-wrapper">
                            <a href="javascript:void(0)" onClick={onShareClick} className="quick-action-item">
                                <img src={shareIcon} alt="" title="Share" />
                                <div className="action-items-title">
                                    Share
                                </div>
                            </a>
                        </div>
                        <div className="quick-action-divider"></div>
                        {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? <>
                            <div className="action-items-inner-wrapper">
                                <Link target="_blank" to={url} onClick={onDownloadClick} className="quick-action-item">
                                    <img src={downloadIcon} alt="" title="Download" />
                                    <div className="action-items-title">
                                        Download
                                    </div>
                                </Link>
                            </div>
                        </> : <>
                            <div className="action-items-inner-wrapper">
                                <Link target="_blank" to={url} onClick={onPubMedDownloadClick} className="quick-action-item">
                                    <img src={downloadIcon} alt="" title="Download" />
                                    <div className="action-items-title">
                                        Download
                                    </div>
                                </Link>
                            </div></>}
                        {(window.location.pathname !== '/pubMedResults') && <div className="quick-action-divider"></div>}
                        {(window.location.pathname === '/viewReadingList' || window.location.pathname === '/old_viewReadingList' || window.location.pathname === '/viewPubMedReadingList') ?
                            window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={e => { handleUnpin(item); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Unpin', '', ''); }}>
                                    <img src={pushPinIcon} alt="" title="Unpin from Reading List" />
                                    <div className="action-items-title">
                                        Unpin
                                    </div>
                                </a>
                            </div>
                            : window.location.pathname !== '/pubMedResults' &&
                            <div className="action-items-inner-wrapper">
                                <a href="javascript:void(0)" className="quick-action-item" onClick={e => { setShowRL(true); indexData(item, url, appliedFilters, searchKeyword, pageNumber, pageSize, 'Pin', '', '') }}>
                                    <img src={pushPinIcon} alt="" title="Pin to Reading List" />
                                    <div className="action-items-title">
                                        Pin
                                    </div>
                                </a>
                            </div>
                        } */}
                {isOpen &&
                    <div>
                        <SharePopup isOpen={isOpen} item={item} appliedFilters={appliedFilters} searchKeyword={searchKeyword} pageNumber={pageNumber} pageSize={pageSize} handleClose={(close) => { setOpenState(close) }} csPath={csPath} csproduct={csproduct} customWidth={customWidth}></SharePopup>
                    </div>
                }
                {showReadingList &&
                    <GenAIPinToReadingListPopUp showModal={showReadingList} handleClose={handleClosePinToReadingList} width={customWidth} docID={item.searchID} />
                }
                {(showPreview || showAuthoring) && (window.location.pathname !== '/pubMedResults'
                    && window.location.pathname !== '/viewPubMedReadingList')
                    && (isShowAuthoring()) && <>
                        {item.domain !== "MLR" ? <>{renderModelPopup()}</> : <>
                            {(() => {
                                if (item.docType
                                    && item.docType.includes('Publications')
                                    && item.genAIEnabled) {
                                    return (<DocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={showPreview} handleClose={handlePreviewClose} />)
                                }
                                else if (item.docType
                                    && !item.docType.includes('Publications')) {
                                    return (<>{renderModelPopup()}</>)
                                }
                                else if (item.docType
                                    && item.docType.includes('Publications')
                                    && !item.genAIEnabled) {
                                    return (<DocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={showPreview} handleClose={handlePreviewClose} />)
                                }

                            })()}

                        </>}
                    </>}
                <Modal
                    show={showAuthoringEnablePanel}
                    size="xl"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="gen-ai-enable-authoring-popup-transition"
                    className="gen-ai-enable-authoring-z-index-preview"
                    backdropClassName="gen-ai-enable-authoring-z-index-preview-backdrop"
                    scrollable={false}
                >
                    <Modal.Body>
                        <AuthoringEnablePanel
                            customWidth={customWidth}
                            customHeight={window.innerHeight}
                            item={item}
                            handleShowAuthoringEnablePanelClick={handleShowAuthoringEnablePanelClick}>
                        </AuthoringEnablePanel>
                    </Modal.Body>
                </Modal>
                {/* {(showPreview && window.location.pathname !== '/nlpresults') &&
                            <DocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview}  showPreview={showPreview} handleClose={handlePreviewClose} />
                        } */}
                {/*{isProcessing &&
                            <Modal
                                show={isProcessing}
                                size="lg md sm xs"
                                centered
                                aria-labelledby="contained-modal-title-vcenter"
                                dialogClassName="savePopUp"
                                className="gen-ai-answering-search-spinner-popup"
                                backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                                scrollable={true}>
                                <div style={{ padding: "0 5%" }}>
                                    <div style={{ fontSize: "14px", textAlign: "center" }}>
                                        <Modal.Body>
                                            <img src={imsLoader} alt="" width={100} height={100} />
                                            <div className="saveModal-heading" style={{ color: "#0074B0" }}>{`Please wait while loading the document.`} </div>
                                        </Modal.Body>
                                    </div>
                                </div>
                            </Modal>}*/}
                {showDisclaimerPopup && <AuthoringDisclaimer showPopup={showDisclaimerPopup} handleDisclaimerClose={handleDisclaimerClose} />}
            </>
            {/* </div> */}
        </>
        )
    }
    function renderModelPopup() {
        return (<Modal
            show={(showPreview || showAuthoring)}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="authoring-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}
        >
            <Modal.Body>
                <Tabs
                    defaultTab={selectedTab.toString()}
                    selectedindex={selectedTab}
                    onClick={handleOnTabClick}
                >
                    <TabList className="tablist-item-notebook" style={{ width: "49.5%", marginLeft: "50%", marginTop: '2px' }}>
                        <Tab tabFor="0" className={selectedTab === '0' ? "tab-list-item-notebook  tab-list-item-notebook-active" : "tab-list-item-notebook"}>Search</Tab>
                        <Tab tabFor="1" className={selectedTab === '1' ? "tab-list-item-notebook tab-list-item-notebook-active" : "tab-list-item-notebook"}>Authoring</Tab>
                        <span style={{ cursor: "pointer", float: "right" }}>
                            {selectedTab === '1' && <>
                                <a className="authoring-model-body-content-link" onClick={() => setShowDisclaimerPopup(true)} >Gen Ai Adherence Policy</a>
                                &nbsp;&nbsp;&nbsp;&nbsp;</>}
                            <img onClick={e => { handleAuthoringClose() }} src={crossIcon} width={10} height={10} alt="Cross" /></span>
                    </TabList>

                    <TabPanel tabId="0" className='tabpanel-list-item-notebook'>
                        <AiNotebookDocumentPreview customWidth={customWidth} sourceItem={item} fileName={item.fileName} docTitle={item.docTitle} searchID={item.searchID} searchKeyword={searchKeyword} synonyms={synonymsForDocumentPreview} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={(showPreview || showAuthoring)} handleClose={handlePreviewClose} isOpenAuthoringTab={false} />
                    </TabPanel>
                    <TabPanel tabId="1" className='tabpanel-list-item-notebook'>
                        <div className="ai-notebook-doc-authoring-wrapper">
                            {(isProcessing) ? <div style={{ textAlign: "center", padding: "10%" }} className="nlp-doc-preview-loader-wrapper">
                                <b>Loading a document</b>
                                <br />
                                <img src={imsLoader} alt="Loading Filters" width={100} height={100} />
                            </div> :
                                <GenAIAuthoringIndex customWidth={customWidth} customHeight={window.innerHeight} attachedFiles={attachedFiles} sessionID={sessionID} isFromCore={true} handleClose={handleAuthoringClose} />}
                        </div>
                    </TabPanel>
                </Tabs>

            </Modal.Body>
        </Modal>)
    }
}